import { showMsg } from '@/utils/snackbar'

export default {
    mounted(el, binding) {

        const max = binding.value

        let timeout = null

        el.addEventListener('input', (e) => {

            const value = e.target.value

            const sliced =
                value.slice(0, max)

            // اگر از حد مجاز بیشتر بود
            if (value !== sliced) {

                // جلوگیری از spam شدن snackbar
                if (!timeout) {

                    showMsg(
                        `حداکثر ${max} کاراکتر مجاز است`,
                        'red'
                    )

                    timeout = setTimeout(() => {
                        timeout = null
                    }, 1500)
                }

                e.target.value = sliced

                e.target.dispatchEvent(
                    new Event('input', { bubbles: true })
                )
            }

        })
    }
}
